// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___t7wd","textContainer":"styles_textContainer__eX1l2","currentAmount":"styles_currentAmount__k1iLH","maxAmount":"styles_maxAmount__bZiTB"};